import { render, staticRenderFns } from "./DoubleCrochetIcon.vue?vue&type=template&id=24e2a03f&scoped=true"
import script from "./DoubleCrochetIcon.vue?vue&type=script&lang=js"
export * from "./DoubleCrochetIcon.vue?vue&type=script&lang=js"
import style0 from "./DoubleCrochetIcon.vue?vue&type=style&index=0&id=24e2a03f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e2a03f",
  null
  
)

export default component.exports